import { deleteVersion } from '@proxies/deleteProyect'
import * as Dialog from '@radix-ui/react-dialog'
import { useAppStore } from '@store'
import { useNavigate, useParams } from 'react-router-dom'

export default function USureModal() {
  const navigate = useNavigate()
  const { idVersiones } = useParams()
  if (!idVersiones) {
    return null
  }

  const closeModal = useAppStore.use.closeModal()
  async function deleteVers() {
    if (typeof idVersiones !== 'string') return null
    const idVers = parseInt(idVersiones)
    await deleteVersion(idVers, navigate)
  }
  return (
    <Dialog.Root open={true}>
      <Dialog.Portal>
        <Dialog.Overlay className='fixed inset-0 z-20 bg-black opacity-30' />
        <Dialog.Content className='dialog text-md absolute left-1/2 top-1/2 z-50 h-min w-80 -translate-x-1/2 -translate-y-1/2 border-2 border-colorAtemporal bg-C/Color1 p-2 text-left'>
          <Dialog.Title className='sr-only'>
            {'Esta acción eliminará para siempre el proyecto, ¿Está seguro de querer hacer esto?'}
          </Dialog.Title>
          <Dialog.Description className='sr-only'>
            {'Esta acción eliminará para siempre el proyecto, ¿Está seguro de querer hacer esto?'} -{' '}
            {'Ok'} / {'Cancelar'}
          </Dialog.Description>
          <div className='flex flex-col items-center justify-center gap-y-1.5'>
            <p className='mt-2 text-center font-normal'>
              {'Esta acción eliminará para siempre el proyecto, ¿Está seguro de querer hacer esto?'}
            </p>
            <div className='button container mb-2 mt-2 flex w-full justify-center gap-3'>
              <button
                onClick={() => {
                  deleteVers()
                }}
                className='flex cursor-pointer items-center rounded-xl bg-colorAtemporal px-4 text-sm font-normal text-C/Color1'
              >
                {'Ok'}
              </button>
              <button
                onClick={() => {
                  closeModal()
                  navigate(-1)
                }}
                className='flex cursor-pointer items-center rounded-xl border border-C/Color3 bg-C/Color7 px-4 py-0.5 text-sm font-normal text-C/Color3'
              >
                {'Cancelar'}
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
